import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-vat-report',
  templateUrl: './vat-report.component.html',
  styleUrls: ['./vat-report.component.css']
})
export class VatReportComponent implements OnInit {
    businessCoNo;

    accountingYear;

    vatReportKeyno;

    public edit?: Edit;

    public selectListTaxPeriods: TaxPeriodItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.businessCoNo = this.stateService.getStateParams()['businessco_no'];
        this.accountingYear = this.stateService.getStateParams()['accounting_year'];
        this.vatReportKeyno = this.stateService.getStateParams()['vatreport_keyno'];
    }

    private async loadEdit() {
        if (!!this.businessCoNo && !!this.accountingYear && !!this.vatReportKeyno) {
            this.edit = (await this.datatask.Post(3132, {
                businessco_no: this.businessCoNo,
                accounting_year: this.accountingYear,
                vatreport_keyno: this.vatReportKeyno
            }))[0];
        }
    }

    private async loadTaxPeriods() {
        if (!this.edit) return;

        return this.selectListTaxPeriods = await this.datatask.Post(3131, {
            businessco_no: this.edit.businessco_no,
            accounting_year: this.edit.accounting_year,
            vatreport_keyno: this.edit.vatreport_keyno
        });
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3133, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadTaxPeriods();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    businessco_no: string;
    businessco_companyname: string;
    accounting_year: string;
    taxperiod_no: string;
    vatreport_keyno: string;
}

interface TaxPeriodItem {
    taxperiod_no: string;
    taxperiod_name: string;
    orderby: number;
}
